/**
 * Connection events service — admin-facing agent <-> BE audit log.
 *
 * Backed by GET /api/agents/connection-events. Used by the /logs tab so
 * admins can answer "did this NV's agent ever register? when did it last
 * heartbeat? are we seeing auth_failed spikes from one IP?".
 */
import type {
  AgentConnectionEvent,
  AgentConnectionEventType,
} from '@monitor/shared'
import { httpClient } from '@/lib/axios'

export interface ListParams {
  page?: number
  pageSize?: number
  employeeId?: number
  eventType?: AgentConnectionEventType
  ok?: boolean
  search?: string
}

export interface ListResponse {
  items: AgentConnectionEvent[]
  total: number
  page: number
  pageSize: number
  summary: {
    total: number
    failures: number
    lastRegisterAt: string | null
    lastAuthFailedAt: string | null
  }
}

export const connectionEventsService = {
  async list(params: ListParams = {}): Promise<ListResponse> {
    const r = await httpClient.get<ListResponse>('/api/agents/connection-events', { params })
    return r.data
  },
}
